<template>
  <div>
    <div class="row">
      <div class="col"></div>
      <div class="col-lg-5">
        <div class="form-group">
          <label for="brutto">{{ T.haviBruttoBer[lang] }}</label>
          <div class="input-group input-group-lg">
            <input
              id="brutto"
              :value="brutto"
              @input="updateBrutto"
              class="form-control"
              aria-label="Bruttó bér"
              type="number"
              min="100"
            />
            <span class="input-group-addon">Ft</span>
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>
    <div class="row mt-2">
      <div class="col"></div>
      <div class="col-lg-5">
        <div class="form-group">
          <input
            :value="brutto"
            @input="updateBrutto"
            class="form-control"
            type="range"
            min="100"
            max="2000000"
            style="width: 100%"
          />
        </div>
      </div>
      <div class="col"></div>
    </div>
    <div class="row mb-2">
      <div class="col"></div>
      <div class="col-lg-5 text-center">
          <button type="button" class="btn btn-secondary mr-3" v-on:click="adjust(-5)">-5%</button>
          <button type="button" class="btn btn-secondary mr-3" v-on:click="adjust(-1)">-1%</button>
          <button type="button" class="btn btn-secondary mr-3" v-on:click="resetAdjustment">🔄</button>
          <button type="button" class="btn btn-secondary mr-3" v-on:click="adjust(1)">+1%</button>
          <button type="button" class="btn btn-secondary" v-on:click="adjust(5)">+5%</button>
      </div>
      <div class="col"></div>
    </div>
    <div class="row mb-2" v-if="adjustment !== 0">
      <div class="col"></div>
      <div class="col-lg-5 text-center">
          <i style="color: gray;margin-right: 0.5em">
            {{format(originalBrutto, false)}}&nbsp;
            {{adjustment > 0 ? "+" : "-"}}&nbsp;
            {{Math.abs(adjustment)}}%
            ({{format(adjustmentAmount, true)}} Ft)
          </i>
      </div>
      <div class="col"></div>
    </div>
    <div class="row">
      <div class="col"></div>
      <div class="col-lg-5 text-center">
        <div class="btn-group btn-group-sm" role="group">
          <button type="button" class="btn btn-secondary" v-on:click="minimalber">{{ T.minimalber[lang] }}</button>
          <button type="button" class="btn btn-secondary" v-on:click="berminimum">{{ T.berminimum[lang] }}</button>
          <button type="button" class="btn btn-secondary" v-on:click="atlagber">{{ T.atlagber[lang] }}</button>
        </div>
      </div>
      <div class="col"></div>
    </div>
    <div class="row mt-2">
      <div class="col"></div>
      <div class="col-lg-5">
        <div class="form-group">
          <label for="netto">{{ T.nettoBer[lang] }}</label>
          <div class="input-group input-group-lg">
            <input
              v-model="netto"
              id="netto"
              class="form-control"
              aria-label="Nettó bér"
              type="number"
              min="0"
              value="300000"
            />
            <span class="input-group-addon">Ft</span>
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>
    <div class="row">
      <div class="col"></div>
      <div class="col-lg-5">
        <div class="form-check">
          <label class="form-check-label" for="frissHazas">
            <input
              v-model="frissHazas"
              id="frissHazas"
              class="form-check-input"
              aria-label="Friss házasok kedvezménye"
              type="checkbox"
            />
            {{ T.frissHazasokKedvezmenye[lang] }}
          </label>
        </div>
      </div>
      <div class="col"></div>
    </div>
    <div class="row">
      <div class="col"></div>
      <div class="col-lg-5">
        <div class="form-check">
          <label class="form-check-label" for="fiatal">
            <input
              v-model="fiatal"
              id="fiatal"
              class="form-check-input"
              aria-label="25 év alattiak szja-mentessége"
              type="checkbox"
            />
            {{ T.szjaMentesseg[lang] }}
          </label>
        </div>
      </div>
      <div class="col"></div>
    </div>
    <div class="row">
      <div class="col"></div>
      <div class="col-lg-5">
        <div class="form-check">
          <label class="form-check-label" for="szjaMentesAnya">
            <input
              v-model="szjaMentesAnya"
              id="szjaMentesAnya"
              class="form-check-input"
              aria-label="SZJA-mentes anya"
              type="checkbox"
            />
            {{ T.szjaMentesAnya[lang] }}
          </label>
        </div>
      </div>
      <div class="col"></div>
    </div>
    <div class="row">
      <div class="col"></div>
      <div class="col-lg-5">
        <div class="form-check">
          <label class="form-check-label" for="fiatalAnya">
            <input
              v-model="fiatalAnya"
              id="fiatalAnya"
              class="form-check-input"
              aria-label="30 év alatti anya"
              type="checkbox"
            />
            {{ T.fiatalAnya[lang] }}
          </label>
        </div>
      </div>
      <div class="col"></div>
    </div>
    <div class="row">
      <div class="col"></div>
      <div class="col-lg-5">
        <div class="form-check">
          <label class="form-check-label" for="szemelyi">
            <input
              v-model="szemelyi"
              id="szemelyi"
              class="form-check-input"
              aria-label="Személyi kedvezmény"
              type="checkbox"
            />
            {{ T.szemelyiKedvezmeny[lang] }}
          </label>
        </div>
      </div>
      <div class="col"></div>
    </div>
    <div class="row mt-1">
      <div class="col"></div>
      <div class="col-lg-5">
        <div class="form-group">
          <label for="kedveltartott">{{ T.kedvezmenyezettEltartott[lang] }}</label>
          <select v-model="kedveltartott" id="kedveltartott" class="form-control">
            <option value="0">0</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
          </select>
        </div>
        <div class="form-group">
          <label for="nemkedveltartott">{{ T.nemKedvezmenyezettEltartott[lang] }}</label>
          <select v-model="nemkedveltartott" id="nemkedveltartott" class="form-control">
            <option value="0">0</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">&gt;2</option>
          </select>
        </div>
      </div>
      <div class="col"></div>
    </div>
    <div class="row">
      <div class="col"></div>
      <div class="col-lg-5">
        <a href="#" aria-controls="privacyInfo" v-on:click="showSickleave">{{ T.betegszabadsag[lang] }}</a>
      </div>
      <div class="col"></div>
    </div>
    <div class="row mt-2">
      <div class="col"></div>
      <div class="col-12 col-md-8 text-center">
        <div
          id="sickleaveInfo"
          class="alert alert-info"
          role="alert"
          v-bind:class="{'collapse.show' : sickleaveShow, 'collapse': !sickleaveShow}"
        >
          <p class="text-justify">
            <strong>{{ T.betegszabadsag[lang] }}:</strong>
            {{ T.betegszabadsagInfo[lang] }}
          </p>
        </div>
      </div>
      <div class="col"></div>
    </div>
    <div class="row" v-bind:class="{'d-none' : !sickleaveShow}">
      <div class="col"></div>
      <div class="col-lg-5">
        <div class="form-group">
          <label for="sickleaveMonth">{{ T.honap[lang] }}</label>
          <select v-model="sickleaveMonth" id="sickleaveMonth" class="form-control">
            <option v-for="(month, index) in T.months[lang]" :key="index" :value="index + 1">{{ month }}</option>
          </select>
        </div>
      </div>
      <div class="col"></div>
    </div>
    <div class="row mb-2" v-bind:class="{'d-none' : !sickleaveShow}">
      <div class="col"></div>
      <div class="col-lg-5">
        <div class="form-group">
          <label for="sickleaveCount">{{ T.betegszabadsag[lang] }}</label>
          <input
            type="number"
            class="form-control"
            id="sickleaveCount"
            v-model="sickleaveCount"
            min="0"
            max="15"
          >
        </div>
      </div>
      <div class="col"></div>
    </div>
  </div>
</template>

<script>
import {
  getLang,
  bruttoToData,
  getQueryVariable,
  MINIMALBER,
  BERMINIMUM,
  ATLAGBER,
  DREAMJOBS,
} from "../js/main.js";
import { T } from "../js/translations.js";

export default {
  props: {
    initialValue: {
      type: Number,
      required: true
    },
    taxes: {
      type: Object,
      required: true
    },
    year: {
      type: Number,
      required: true
    },
    lang: String
  },
  model: {
    prop: "taxes",
    event: "taxes-changed"
  },
  data: function() {
    return {
      adjustment: 0,
      brutto: this.initialValue,
      fiatal: false,
      fiatalAnya: false,
      frissHazas: false,
      dreamjobs: DREAMJOBS,
      kedveltartott: 0,
      szjaMentesAnya: false,
      nemkedveltartott: 0,
      originalBrutto: this.initialValue,
      originalNetto: 0,
      sickleaveCount: 0,
      sickleaveMonth: (new Date()).getMonth()+1,
      sickleaveShow: false,
      szemelyi: false,
      T: T
    };
  },
  computed: {
    adjustmentAmount: function() {
      return this.brutto - this.originalBrutto;
    },
    netto: {
      get: function() {
        return this.taxes["netto"];
      },
      set: function(newValue) {
        this.brutto = this.calculateBruttoFromNetto(newValue);
        this.originalBrutto = this.brutto;
        this.originalNetto = newValue;
        this.adjustment = 0;
      }
    }
  },
  watch: {
    taxes: function(newTaxes) {
      this.updateURL();
    },
    brutto: function(newBrutto) {
      this.recalculateTaxes();
    },
    frissHazas: function(newValue) {
      this.recalculateTaxes();
    },
    fiatal: function(newValue) {
      this.recalculateTaxes();
    },
    fiatalAnya: function(newValue) {
      this.recalculateTaxes();
    },
    kedveltartott: function(newValue) {
      this.recalculateTaxes();
    },
    nemkedveltartott: function(newValue) {
      this.recalculateTaxes();
    },
    szjaMentesAnya: function(newValue) {
      this.recalculateTaxes();
    },
    szemelyi: function(newValue) {
      this.recalculateTaxes();
    },
    year: function(newValue) {
      this.recalculateTaxes();
    },
    sickleaveMonth: function() {
      this.recalculateTaxes();
    },
    sickleaveCount: function() {
      this.recalculateTaxes();
    },
  },
  methods: {
    format: function(value, sign) {
      if (isNaN(value)) {
        return "";
      }
      return new Intl.NumberFormat('hu-HU', {
        maximumFractionDigits: 0,
        signDisplay: sign ? 'always' : 'auto'
      }).format(value);
    },
    adjust: function(percent) {
      this.adjustment += percent;
      this.brutto = Math.round(this.originalBrutto * (1 + this.adjustment / 100));
    },
    resetAdjustment: function() {
      this.adjustment = 0;
      this.brutto = this.originalBrutto;
    },
    updateOriginalsFromBrutto: function(brutto) {
        this.brutto = brutto;
        this.originalBrutto = brutto;
        this.adjustment = 0;
        this.originalNetto = this.calculateTaxes().netto;
    },
    minimalber: function() {
      this.updateOriginalsFromBrutto(MINIMALBER[this.year]);
    },
    berminimum: function() {
      this.updateOriginalsFromBrutto(BERMINIMUM[this.year]);
    },
    atlagber: function() {
      this.updateOriginalsFromBrutto(ATLAGBER[this.year]);
    },
    calculateTaxes: function() {
      return bruttoToData(
        this.year,
        this.brutto,
        this.kedveltartott,
        this.nemkedveltartott,
        this.frissHazas,
        this.fiatal,
        this.sickleaveMonth,
        this.sickleaveCount,
        this.szjaMentesAnya,
        this.fiatalAnya,  // fiatalanya - 30 év alatti anya
        this.szemelyi    // szemelyi - személyi kedvezmény
      );
    },
    recalculateTaxes: function() {
      var newTaxes = this.calculateTaxes();
      this.$emit("taxes-changed", newTaxes);
    },
    processParameters: function() {
      var brutto = parseInt(getQueryVariable("brutto"));
      if (isNaN(brutto)) {
        return;
      }
      var kedv = parseInt(getQueryVariable("kedv")) || 0;
      var nemkedv = parseInt(getQueryVariable("nemkedv")) || 0;
      var frisshazas = getQueryVariable("frissHazas") === "true";
      var fiatal = getQueryVariable("fiatal") === "true";
      var szjaMentesAnya = getQueryVariable("szjaMentesAnya") === "true";
      var fiatalAnya = getQueryVariable("fiatalAnya") === "true";
      var szemelyi = getQueryVariable("szemelyi") === "true";
      var sickleaveMonth = parseInt(getQueryVariable("sickleaveMonth")) || 1;
      var sickleaveCount = parseInt(getQueryVariable("sickleaveCount")) || 0;

      if (kedv > 6) {
        kedv = 6;
      }
      if (kedv < 0) {
        kedv = 0;
      }
      if (nemkedv > 6) {
        nemkedv = 6;
      }
      if (nemkedv < 0) {
        nemkedv = 0;
      }
      if (sickleaveMonth < 1 || sickleaveMonth > 12) {
        sickleaveMonth = 1;
      }
      if (sickleaveCount < 0 || sickleaveCount > 15) {
        sickleaveCount = 0;
      }
      this.brutto = brutto;
      this.kedveltartott = kedv;
      this.nemkedveltartott = nemkedv;
      this.frissHazas = frisshazas;
      this.fiatal = fiatal;
      this.szjaMentesAnya = szjaMentesAnya;
      this.fiatalAnya = fiatalAnya;
      this.szemelyi = szemelyi;
      this.sickleaveMonth = sickleaveMonth;
      this.sickleaveCount = sickleaveCount;
      this.sickleaveShow = sickleaveCount > 0;
    },
    updateURL: function() {
      var url = "index.html?";
      url += "brutto=" + this.brutto;
      url += "&kedv=" + this.kedveltartott;
      url += "&nemkedv=" + this.nemkedveltartott;
      url += "&frissHazas=" + this.frissHazas;
      url += "&fiatal=" + this.fiatal;
      url += "&szjaMentesAnya=" + this.szjaMentesAnya;
      url += "&fiatalAnya=" + this.fiatalAnya;
      url += "&szemelyi=" + this.szemelyi;
      url += "&year=" + this.year;
      url += "&sickleaveMonth=" + this.sickleaveMonth;
      url += "&sickleaveCount=" + this.sickleaveCount;
      url += "&theme=" + getQueryVariable("theme");
      url += "&lang=" + getLang();
      window.history.replaceState(null, document.title, url);
    },
    updateBrutto: function(e) {
      this.updateOriginalsFromBrutto(parseInt(e.target.value));
    },
    calculateBruttoFromNetto: function(netto) {
      var act = Math.round(netto * 1.5);
      var diff = 100;
      while (Math.abs(diff) > 0) {
        diff =
          netto -
          bruttoToData(
            this.year,
            act,
            this.kedveltartott,
            this.nemkedveltartott,
            this.frissHazas,
            this.fiatal,
            this.sickleaveMonth,
            this.sickleaveCount,
            this.szjaMentesAnya,
            this.fiatalAnya,  // fiatalanya - 30 év alatti anya
            this.szemelyi    // szemelyi - személyi kedvezmény
          )["netto"];
        act = act + diff;
      }
      return act;
    },
    showSickleave: function(e) {
      e.preventDefault();
      this.sickleaveShow = !this.sickleaveShow;
    }
  },
  created: function() {
    this.processParameters();
    this.recalculateTaxes();
    this.originalNetto = this.calculateTaxes().netto;
  }
};
</script>



// WEBPACK FOOTER //
// Calculator.vue?3186cb1d